import MenuItem from 'antd/lib/menu/MenuItem';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { theme } from '../ui/themes/default';

export const ExpandedLogoWrapper = styled.img`
  margin: 32px 0 22px 32px;
  height: 40px;
  width: 190px;
`;

export const CollapsedLogoWrapper = styled.img`
  height: 40px;
  margin: 32px 0 22px 32px;
`;

export const CollapseButton = styled.div`
  background: ${theme.white};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-shadow: 6px 6px 24px ${theme.boxShadow};
  position: absolute;
  top: 44px;
  right: -16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;

  &:hover {
    background: ${theme.menuActiveItemBackground};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${theme.mainBlack} !important;
`;

export const PhoneLink = styled.a`
  color: ${theme.mainBlack} !important;
  display: flex;
`;

export const MenuLabel = styled.span`
  font-weight: 500;
  font-size: 16px;
`;

export const StyledMenuItem = styled(MenuItem)<{ active: boolean; collapsed?: boolean }>`
  height: 56px !important;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  border-left: ${({ active }) => `4px solid ${active ? theme.mainBlack : theme.mediumGrey}`};
  padding: ${({ collapsed }) => (collapsed ? '0 24px !important' : '0 16px')};

  > span {
    display: flex;
    align-items: center;
  }

  &:hover {
    background: ${theme.menuActiveItemBackground};
  }

  &.ant-menu-item-selected ${MenuLabel} {
    font-weight: 700;
  }
`;

export const EmergencySection = styled.div<{ collapsed: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  margin: 16px 0 32px;
  padding: 0 16px;
`;

export const StyledDropdownMenu = styled.div`
  margin-bottom: 5px;
  .ant-dropdown-menu {
    padding: 0;
    overflow: hidden;
  }
  .ant-dropdown-menu-item {
    padding: 6px 20px;
    &:after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      height: 1px;
      width: 100%;
      background: ${theme.grey};
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`;

export const StyledDropdownWrap = styled.div`
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  transition: all ease 0.3s;
`;

export const StyledDropdownItem = styled.span`
  display: flex;
  margin-left: 18px;
  padding-right: 13px;
  flex-direction: column;
`;

export const StyledDropdownItemText = styled.span`
  .ant-typography {
    font-weight: 400;
  }
`;
export const StyledDivider = styled.span`
  display: block;
  width: 100%;
  height: 1px;
  background: ${theme.grey};
  margin-top: 10px;
`;
export const StyledCopy = styled.span`
  position: relative;
  align-self: end;
  bottom: 2px;
  left: -10px;
  padding: 2px;
  height: 20px;
  z-index: 2;
`;

export const StyledLinkDropdown = styled.a`
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  transition: all ease 0.3s;
`;
